export default __webpack_public_path__ + "static/media/main-findings.60bfcf9b.pdf";